import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useEffect, useRef, useState } from 'react'

function formatElapsedDuration(elapsedMs: number): string {
  const totalSec = Math.floor(elapsedMs / 1000)
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const s = totalSec % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export interface TimeAndGameNameProps {
  x: number
  y: number
}

export const SessionTime = (props: TimeAndGameNameProps) => {
  const [elapsedStr, setElapsedStr] = useState('00:00:00')
  const sessionStartedAtMs = useRef(Date.now())

  useEffect(() => {
    const tick = () => {
      setElapsedStr(formatElapsedDuration(Date.now() - sessionStartedAtMs.current))
    }

    tick()
    const timer = setInterval(tick, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <Text
      text={'⌛' + elapsedStr}
      x={props.x / 2.5}
      y={props.y + 30}
      style={textStyle}
      anchor={0.5}
    />

  )
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 25,
  fill: '#ffffff',
  fontWeight: 'bold',
})
